import { comments } from '@/mocks/home';

const avatarColors = [
  'bg-primary-500',
  'bg-accent-500',
  'bg-secondary-500',
  'bg-primary-400',
  'bg-accent-400',
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-secondary-100/70 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-heart-line text-xs"></i>
            <span>漫友评价</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            漫迷心声
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            来自真实漫迷的使用反馈与推荐
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {comments.map((comment, i) => {
              const isLastOdd = comments.length % 2 === 1 && i === comments.length - 1;
              return (
                <div
                  key={i}
                  className={`bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200/30 transition-colors ${
                    isLastOdd ? 'md:col-span-2 lg:col-span-1' : ''
                  }`}
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className={`w-10 h-10 flex items-center justify-center rounded-full shrink-0 ${avatarColors[i % avatarColors.length]}`}
                    >
                      <span className="text-background-50 text-sm font-bold whitespace-nowrap">
                        {comment.avatar.slice(-2)}
                      </span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{comment.avatar}</div>
                      <div className="text-xs text-foreground-400">{comment.time}</div>
                    </div>
                    <div className="ml-auto flex gap-0.5">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-xs text-accent-500"></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">{comment.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}